export const exampleCategoryItems = ['Cloudly', 'Bezpečnost', 'Napsali o nás'];
